// Loan officer profiles. Add a new object here to instantly create a page at /<slug>
export const LOAN_OFFICERS = [
  {
    slug: "arizzi",
    firstName: "Alex",
    lastName: "Rizzi",
    name: "Alex Rizzi",
    title: "Mortgage Loan Officer",
    nmls: "2837621",
    phone: "(571) 740-9077",
    phoneDigits: "5717409077",
    email: "arizzi@cityworth.com",
    photo:
      "/img/kmvsry2t.webp",
    loanzifyUrl: "https://cityworth.loanzify.io/register/alex-rizzzi",
    states: [
      { code: "VA", name: "Virginia" },
      { code: "PA", name: "Pennsylvania" },
      { code: "FL", name: "Florida" },
      { code: "SC", name: "South Carolina" },
      { code: "TX", name: "Texas" },
    ],
    tagline: "I like it when my phone rings.",
    intro:
      "The most likely reason you're reading this is because a Realtor, a friend, or a co-worker suggested you contact me to help with your mortgage needs, and for good reason.",
    bio: [
      "This is usually where I would mention that I attended James Madison University and received a BBA in Computer Information Systems, worked as a consultant at Accenture out of college, then left to start my first business called Based Balm which I scaled into seven figures and sold to a larger supplement company. However, instead of stating that, I would just like to simply say that the most likely reason that you are reading this is because a Realtor, a friend, or co-worker suggested that you contact me to help with your mortgage needs, and for good reason!",
      "They know that I work as hard as I can to make this complicated industry as smooth as possible for you and to save you homebuying dollars where I can. I always answer my phone or promptly return messages. (I like it when my phone rings!)",
      "I will provide as much information and explanation during the mortgage process as you would like. I will always give you as much time as you need. I am committed to making sure you feel confident and informed every step of the way.",
      "Closing dates and required time frames will be professionally met by me and our experienced operations staff at CityWorth.",
      "Before getting into mortgages, I built my first business from the ground up, scaled it to seven figures, and sold it. So compared to the challenges of entrepreneurship and scaling a company, getting your loan approved is a piece of cake!",
      "My passion is getting people into their dream homes and making it a memorable experience. I look forward to demonstrating that you will be happy your referral source provided the suggestion.",
    ],
    highlights: [
      { label: "Answers his phone", detail: "Calls & texts returned promptly, usually same hour" },
      { label: "Entrepreneur turned lender", detail: "Built & sold a 7-figure business before mortgages" },
      { label: "On-time closings", detail: "Backed by CityWorth's experienced operations team" },
    ],
  },
];

export const getOfficerBySlug = (slug) =>
  LOAN_OFFICERS.find((o) => o.slug === (slug || "").toLowerCase()) || null;
